define([], function() {
    var _self;
    // console.log('browser');

    // obj
    _self = {
        removeFormValidation: function() {
            $('form').attr('novalidate', 'novalidate');
        }
    };


    // -------------------
    // BINDS
    // -------------------

    _self.removeFormValidation();

    return _self;
});
